(function ($) {
  // Document Ready
  $(document).ready(function () {
    /***************************************************
      Home Parallax Section - IMPORTANT: Needs to be setup separately from the fade-in-up and misc animations
    /*****************************************************/

    gsap.registerPlugin(ScrollTrigger);

    var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

    if ($(".home-parallax-section").length) {
      // Calculate a reasonable end point based on viewport height and content
      const parallaxHeight = window.innerHeight * 1; // 2 viewport heights

      gsap.utils.toArray(".home-parallax-section .container").forEach((el) => {
        gsap.to(el, {
          scrollTrigger: {
            trigger: el,
            start: "top top",
            end: `+=${parallaxHeight}`, // Use calculated height instead of endTrigger
            // markers: true,
            pin: true,
            pinSpacing: true, // Keep this true to prevent overlapping
            invalidateOnRefresh: true,
          },
        });
      });

      // gsap.utils.toArray(".home-parallax-section .image-bubble").forEach((el) => {
      //   gsap.to(el, {
      //     scale: 1,
      //     scrollTrigger: {
      //       trigger: el,
      //       start: "top bottom",
      //       end: "bottom top",
      //       // markers: true,
      //       scrub: 1,
      //       invalidateOnRefresh: true,
      //     },
      //   });
      // });

      // gsap.utils.toArray(".home-parallax-section .logo-contain").forEach((el) => {
      //   gsap.to(el, {
      //     rotation: 720,
      //     scrollTrigger: {
      //       trigger: ".home-parallax-section",
      //       start: "top top",
      //       end: `+=${parallaxHeight}`, // Use same calculated height
      //       // markers: true,
      //       scrub: 0.5,
      //       invalidateOnRefresh: true,
      //     },
      //   });
      // });

      gsap.utils.toArray(".home-parallax-section .scroll-down-wrap").forEach((el) => {
        gsap.to(el, {
          scrollTrigger: {
            trigger: ".home-parallax-section",
            start: "2.5% top",
            end: "10% top", // Much earlier end point
            // markers: true,
            invalidateOnRefresh: true,
            onEnter: () => {
              gsap.to(el, {
                alpha: 0,
                duration: 0.3,
              });
            },
            onLeaveBack: () => {
              gsap.to(el, {
                alpha: 1,
                duration: 0.3,
              });
            },
          },
        });
      });

      gsap.utils
        .toArray(
          ".home-parallax-section .logo-contain, .home-parallax-section .lead-text, .home-parallax-section .intro-text, .home-parallax-section .scroll-down-wrap"
        )
        .forEach((el) => {
          gsap.to(el, {
            alpha: 1,
            y: 0,
            scale: 1,
            scrollTrigger: {
              trigger: ".home-parallax-section",
              start: "top 20%",
              end: "bottom top", // Much earlier end point
              // markers: true,
              invalidateOnRefresh: true,
            },
          });
        });

      // Move fade-in-up animations to run AFTER parallax section setup
      $(window).on("load", function () {
        setTimeout(function () {
          // Refresh all ScrollTriggers to recalculate after pin spacing is applied
          ScrollTrigger.refresh();
        }, 1000); // Slightly longer delay to ensure pin spacing is calculated
      });
    }
  });
})(jQuery);
